export default __webpack_public_path__ + "static/media/icon_calendar.5abcf0d5.svg";